import moment from 'moment'
import React from 'react'
import { useDispatch } from 'react-redux'
import { activeNote } from '../../actions/notes'

const JournalEntry = ({ id, title, body, date, url }) => {

    const noteDate = moment(date)

    const dispatch = useDispatch()

    const handleActiveNote = () => {
        dispatch(activeNote(id, { title, body, date, url }))
    }

    return (
        <div 
            className='journal__entry animate__animated animate__bounceIn' 
            onClick={ handleActiveNote }
        >
            {   ( url ) &&
                <div className="journal__entry-picture">
                    <img src={ `${url}` } alt="title" />
                </div>
            }


            <div className="journal__entry-body">
                <p className='journal__entry-title'>{title}</p>
                <p className="journal__entry-content">
                    { body.slice(0, 30) + '...' }
                </p>
            </div>

            <div className="journal__entry-date-box">
                <span>{noteDate.format('dddd')}</span>
                <h4>{noteDate.format('Do')}</h4>
            </div>
        </div>
    )
}

export default JournalEntry